module.exports = __webpack_public_path__ + "media/app/containers/LandingPage/FarmToTablePage/Images/usp/certifiedIngredients.0e7efea3.svg";